import React, { Component } from "react";
import Divider from "@mui/material/Divider";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import LoadingCircular from "../LoadingCircular";

class Gallery extends Component {
  state = {
    gallerys: [],
    isLoading: false,
  };
  async componentDidMount() {
    this.setState({ isLoading: true });
    const res = await fetch(`/ng/api/GetGallerys/List`);
    const data = await res.json();
    const gallerys = data.map((g) => ({
      ...g,
      thumbnail: `/ng/Content/Img/Gallery/${g.Id}/${g.thumbnail}`,
    }));
    this.setState({ gallerys: gallerys, isLoading: false });
  }
  render() {
    const { handleComToShow, handleGalleryDetail } = this.props;
    const { isLoading } = this.state;
    return (
      <React.Fragment>
        <LoadingCircular open={isLoading} />
        <Divider sx={{ mt: 1, mb: 1 }}>گالری تصاویر</Divider>
        <Box sx={{ width: "100%" }}>
          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          >
            {this.state.gallerys.map((g, index) => (
              <Grid key={index} item xs={4}>
                <Card>
                  <CardActionArea
                    onClick={() => {
                      handleGalleryDetail(g.Id, g.Title, g.Date);
                      handleComToShow("gallerydetail");
                    }}
                  >
                    <CardMedia
                      component="img"
                      height="100"
                      image={g.thumbnail}
                    />
                    <CardContent sx={{ backgroundColor: "#2e2d2b" }}>
                      <Typography gutterBottom variant="body2" component="div">
                        {g.Title}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {g.Date}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      </React.Fragment>
    );
  }
}

export default Gallery;
